import axios from 'axios';
import axiosRetry from "axios-retry";

function createUsageAPIClient(token: string) {
    const instance = axios.create({
        // baseURL: process.env.NODE_ENV === "production"
        //     ? "https://model-usage-api-67jfnx2vvq-uc.a.run.app"
        //     : `${process.env.NEXT_PUBLIC_URL_MODEL_USAGE_API}`,
        baseURL: "https://model-usage-api-67jfnx2vvq-uc.a.run.app",
        headers: {
            token: token
        },
    });

    axiosRetry(instance, {retryDelay: axiosRetry.exponentialDelay});
    return instance;
}

export async function getUsage(token: string, startTime: number, endTime: number, id: string) {
    const req = createUsageAPIClient(token);
    return req.get('/usage', {params: {startTime: startTime, endTime: endTime, id: id}})
}
